var __jsx = React.createElement;
import Image from "next/image";
import React from "react";
function InformationItem(_ref) {
  let {
    title,
    description,
    imageSrc,
    icon,
    brandLogo,
    displayDirection = "row",
    imagePosition,
    imageWidth,
    logoWidth,
    contentClassname,
    titleClassname,
    descriptionClassname,
    containerClasname
  } = _ref;
  return __jsx("div", {
    className: "w-full"
  }, displayDirection === "column" ? __jsx("div", {
    className: "flex flex-col ".concat(containerClasname)
  }, imageSrc ? __jsx("div", {
    className: "w-full",
    style: {
      maxWidth: imageWidth
    }
  }, __jsx(Image, {
    src: imageSrc,
    alt: "image",
    width: imageWidth,
    height: imageWidth,
    loading: "eager"
  })) : icon, title && __jsx("p", {
    className: titleClassname
  }, title), description && __jsx("p", {
    className: descriptionClassname
  }, description)) : __jsx("div", {
    className: "flex flex-col items-center ".concat(containerClasname, " md:flex-row")
  }, imagePosition === "left" && __jsx("div", {
    className: "w-[70%] xs:w-1/2 lg:w-1/3"
  }, imageSrc ? __jsx(Image, {
    src: imageSrc,
    alt: "image",
    width: imageWidth,
    height: imageWidth,
    loading: "eager"
  }) : icon), __jsx("div", {
    className: "w-full flex flex-col ".concat(contentClassname)
  }, __jsx("span", {
    className: "flex flex-wrap gap-2 ".concat(titleClassname)
  }, title && __jsx("p", null, title), brandLogo && __jsx("div", {
    className: "w-fit mb-4 md:w-full"
  }, __jsx(Image, {
    src: brandLogo,
    alt: "image",
    width: logoWidth,
    height: logoWidth,
    loading: "eager"
  }))), description && __jsx("p", {
    className: descriptionClassname
  }, description)), imagePosition === "right" && __jsx("div", {
    className: "w-[70%] xs:w-1/2 lg:w-1/3 order-first md:order-last",
    style: {
      maxWidth: imageWidth
    }
  }, imageSrc ? __jsx(Image, {
    src: imageSrc,
    alt: "image",
    width: imageWidth,
    height: imageWidth
  }) : icon)));
}
export default InformationItem;